import i18n from '@/i18n'
import { getBrowserLang, getLocale } from '@/i18n/i18n-helper'
import server from '@/api/server'

export const HOTSPOT_BASE_SIZE = 51.2

export const SOCIAL = {
  FETCH_COMMENTS_COUNTS_EACH_TIME: 10,
  BASIC_FOLDER: 'social',
  COMMENT_COUNT: 'commentCount',
  LIKE_COUNT: 'likeCount',
  VIEW_COUNT: 'viewCount',
  COMMENTS: 'comments'
}
export const VISITOR = {
  BASIC_FOLDER: 'social',
  USER: 'user',
  VIEW_COUNT: 'viewCount',
  VIEW_LAST_TIME: 'viewLastTime',
  VIEW_SESSION_SEC: 'viewSessionSec'
}

export const WEBINAR = {
  BASIC_FOLDER: 'webinar'
}

export const VRLOUNGE = {
  BASIC_FOLDER: 'vrlounge',
  SERVER: server.loungeUrl,
  TALKJS_APP_ID: server.talkjsAppId,
  COMPANY: {
    WEA: 'wea'
  },
  GROUPS: [
    'a0be8f88-98ca-47bd-b69b-fbda5a944aea', // official prod
    'd2185284-75f4-40b5-8f5d-5cfda1926820', // prod
    'eaeb2cc4-4743-40a3-bc7c-d57423a1cbe6', // dev
    '549b675c-0b6c-4638-a680-b7f48c391a3a' // test
  ]
}

export const CATEGORYNAMES = {
  livingroom: 'livingroom',
  diningroom: 'diningroom',
  kitchen: 'kitchen',
  bedroom: 'bedroom',
  study: 'study',
  bathroom: 'bathroom',
  toilet: 'toilet',
  garden: 'garden',
  garage: 'garage',
  outdoors: 'outdoors',
  others: 'others',
  custom: 'custom'
}

export const CATEGORIES = [{
  value: CATEGORYNAMES.livingroom,
  text: 'categories.livingroom'
}, {
  value: CATEGORYNAMES.diningroom,
  text: 'categories.diningroom'
}, {
  value: CATEGORYNAMES.kitchen,
  text: 'categories.kitchen'
}, {
  value: CATEGORYNAMES.bedroom,
  text: 'categories.bedroom'
}, {
  value: CATEGORYNAMES.study,
  text: 'categories.study'
}, {
  value: CATEGORYNAMES.bathroom,
  text: 'categories.bathroom'
}, {
  value: CATEGORYNAMES.toilet,
  text: 'categories.toilet'
}, {
  value: CATEGORYNAMES.garden,
  text: 'categories.garden'
}, {
  value: CATEGORYNAMES.garage,
  text: 'categories.garage'
}, {
  value: CATEGORYNAMES.outdoors,
  text: 'categories.outdoors'
}, {
  value: CATEGORYNAMES.others,
  text: 'categories.others'
}, {
  value: CATEGORYNAMES.custom,
  text: 'categories.custom'
}]

export const POPUP = {
  TYPE: 'marker', // marker / intro
  FULL_HEIGHT: false,
  WIDTH_PERCENT: 65,
  TRANSPARENT: false
}
export const INTRO_TYPE = {
  BUILDING: 'BUILDING',
  TOURRING: 'TOURRING'
}
export const COMPANY = {
  YUNG_CHING: 'yung-ching',
  U_TRUST: 'u-trust',
  TAI_CHING: 'tai-ching',
  HOUSE_FUN: 'house-fun',
  ETWARM: 'etwarm',
  WEA: 'wea',
  TAIWANTRADE: 'ttmegaexpo',
  YUNG_YI: 'yung-yi',
  TVA: 'tva'
}
export const COLOR = {
  DEFAULT_THEME: 'pink',
  DEFAULT_MAIN_COLOR: '#ec0974',
  DEFAULT_SUB_COLOR: '#662e91',
  ETWARM_THEME: 'etwarm-red',
  ETWARM_MAIN_COLOR: '#e60012',
  ETWARM_SUB_COLOR: '#f49d37',
  BLACK_MAIN_COLOR: '#000000',
  BLACK_SUB_COLOR: '#bcbdc1',
  BLUE_MAIN_COLOR: '#49b9fb',
  BLUE_SUB_COLOR: '#a3d5ff',
  GREEN_MAIN_COLOR: '#61be6b',
  GREEN_SUB_COLOR: '#c3d898',
  ORANGE_MAIN_COLOR: '#f95738',
  ORANGE_SUB_COLOR: '#ffd07b',
  YELLOW_MAIN_COLOR: '#fcbf49',
  YELLOW_SUB_COLOR: '#ffd5c2'
}
export const BUILDING = {
  SHOW_COMMENT: true,
  SHOW_SEARCH: true,
  SHOW_CONTACT_INFO: true,
  SHOW_POWERED_BY: true,
  LOGO_SIZE: 125
}
export const DEFAULT_LOGO_SIZE = 60
export const WHITE_LABEL_CELINE = false

const locale = getLocale(getBrowserLang())
export const MAEKER_CATEGORY_SEARCH_DEFAULT_VALUE = i18n.t('all', locale)
export const CATEGORY_OPTIONS = [
  null,
  'product',
  'company',
  'livetour'
]
export const DISPLAY_SEARCH_RESULT_QTY = 15 // 搜尋結果預設顯示數量
export const KRPANO_SETTING = {
  speed: {
    slow: 200 / 360, // autorotate
    average: 100 / 360,
    fast: 50 / 360, // autopilot
    instant: 0.5 / 360
  },
  time: {
    autoRotate: 200,
    autoStartAutoRotate: 5
  }
}

// Updated: #6589
// dateRange format: '{DATETIME}~{DATETIME}' in array
//   {DATETIME} must have specific timezone, or the time will be parsed depends on visitor's local time zone
//   {DATETIME} format: 0000-00-00 00:00:00+08:00, use * to unset the date
// set dateRange = [] to unset the range
const forcePopupWebTag = {
  dev: {
    buildingId: 'd63a7c14-6ddb-4ad4-b853-6eaedd02fffe',
    panoramaId: 'c0097848-046f-4d87-949f-10bbf268c87a',
    markerId: '93288c92-bf4c-462d-ab55-946fa6e597b6',
    dateRange: [
      '*~2021-04-29 16:00:00+08:00'
    ]
  },
  test: {
    buildingId: '',
    panoramaId: '',
    markerId: '',
    dateRange: []
  },
  prod: {
    buildingId: 'db2b2b5b-373e-46a8-92d3-72909284bcd3',
    panoramaId: '408fdcf6-1fe3-4b45-ba89-c722da737382',
    markerId: '4de35d14-cd54-4fca-8451-a369fce0d95a',
    dateRange: [
      '2021-04-28 15:00:00+08:00~2021-04-28 16:00:00+08:00',
      '2021-04-29 13:00:00+08:00~2021-04-29 16:00:00+08:00'
    ]
  }
}
export const FORCE_POPUP_WEB_TAG = forcePopupWebTag[process.env.NODE_ENV]

// hard code for virtual exhibition
export const VR_EX_CONFIG = {
  propertyIds: [
    '28a788a3-7e83-4b69-9c92-b4f7cb8ec00a',
    '3142fcab-c323-4197-bfdc-6b4556fffb18',
    'a87a141e-263b-4945-8e43-08fea11ab3f3',
    '271054d1-d41c-4b5b-8b02-8d3d0fd3494c',
    '3c0a1a68-e0bb-4a8a-bfe7-23601af33c2e',
    '7cf253ee-9481-4508-adf9-9ef5b63a8cb3',
    'e6693cf5-996b-4619-8318-6c558fe82aa6',
    'a0be8f88-98ca-47bd-b69b-fbda5a944aea'
  ],
  footerDisplayBuilding: {
    // 28a788a3-7e83-4b69-9c92-b4f7cb8ec00a
    'c409c554-86c1-4912-881b-164fbb6af798': true,
    '484009a8-2336-49a0-97ad-e7398ebccf3a': true,
    'ad4a0589-f369-4c8d-b24c-ae335e3158c3': true,
    'a0546e85-5207-44ad-8015-26e10ffa1abe': true,
    '20b8730c-60a8-4308-a095-48796d1d95d3': true,
    'e53889a4-05b8-424b-99b2-10c785e44503': true,
    '90587aee-a9ec-4585-a7a2-f012473f470c': true,
    '8af43909-9285-4962-b17e-af85e1c3492a': true,
    // 3142fcab-c323-4197-bfdc-6b4556fffb18
    '3d11e942-8fc9-49f4-8dff-07140324e7ed': true,
    'e4ce3fbc-7e02-4347-9bf5-9d1364c3fdf2': true,
    'f295d560-a9c3-42d4-9b6b-f1f48df1fb82': true,
    'f71bb4b0-0a75-46aa-a5b8-7cd4f37a96d2': true,
    // a87a141e-263b-4945-8e43-08fea11ab3f3
    '278e1891-b9b9-4cec-a87d-37de5aee2e12': true,
    // 271054d1-d41c-4b5b-8b02-8d3d0fd3494c
    '9830d99f-28b0-4070-9d79-e7c949aa4605': true,
    // 3c0a1a68-e0bb-4a8a-bfe7-23601af33c2e
    '7471b848-fbc1-49ca-92e5-1a1dcc01894d': true,
    // 7cf253ee-9481-4508-adf9-9ef5b63a8cb3
    'bfa592ee-e687-41b0-ac2d-038233c6eb75': true,
    // e6693cf5-996b-4619-8318-6c558fe82aa6
    '45a10959-bf7c-4d64-bf6e-940fdcd90e6a': true,
    // a0be8f88-98ca-47bd-b69b-fbda5a944aea
    '13d4f4a2-2a6d-46f9-a645-18ead06e9cdc': true
  }
}

// hard code for ces outer navigation
export const cesNavigationConfig = {
  buildingId: 'f61536ff-5b81-49fd-ba52-8564c2fb8ad7',
  storeId: 'ea3d38fa-ba4b-4dc8-b0b5-96648827f6d1',
  homePanoramaId: 'ee7dc5c7-cdd1-4167-8a66-45e31369ddd6',
  awardPanoramaId: '0cd1b495-508d-4332-9322-242558e01590',
  cybersecurityPanoramaId: 'c6694657-c4dd-4467-a8a3-17e9ef099653',
  healthCarePanoramaId: 'b6bdab3b-99d0-441d-ad35-e187c0d74c5f',
  livePanoramaId: 'a3fcd573-db86-4e50-8d23-46a9a4416244',
  mobilityPanoramaId: '072a5db4-745f-41a7-94b4-a6ca914937ab',
  smartLivingPanoramaId: '7234b899-b878-4f9f-a15a-e4bfaeee0068',
  techForGoodPanoramaId: '936c0faf-cc6f-470a-86c1-87d092403285',
  contactUsUrl: 'https://forms.gle/w2Ktg2noxJS6xAvX7',
  cesUrl: 'https://www.ces.tech/2021-exhibitor-microsite.aspx',
  agendaOne: 'https://www.youtube.com/watch?v=kHGik_g-o2k&feature=youtu.be',
  agendaTwo: 'https://digital.ces.tech/sessions/b9a1efc9-e781-4e5c-9a5f-fdec9a0024c6',
  agendaThree: 'https://digital.ces.tech/sessions/f83dd4a1-3c39-451d-82fc-75495beb0c51',
  agendaFour: 'https://taiwantecharena.webex.com/taiwantecharena-tc/j.php?MTID=ma76dec1e0e76c9e72b1d046712069e29',
  agendaFive: 'https://reurl.cc/R6n7v6',
  agendaSix: 'https://digital.ces.tech/sessions/37ab6853-f0ea-46cf-ba32-3ca6976f06e2?source=sessions',
  agendaSeven: 'https://digital.ces.tech/sessions/a936cc02-28cb-45fd-93af-9cca448f0886?source=sessions',
  agendaEight: 'https://reurl.cc/4y5DXK'
}

export const yachtBuildingId = '57e6aea7-c5c8-4320-a2d2-fd67ae5381fc'

export const weaNotPublicConfig = {
  iconUrl: 'https://storage.googleapis.com/vrmaker/00000photoUpload/WEA%202020-logo_RGB-01-final.png'
}

export const loadingBarCustomConfig = {
  videoSrc: 'https://dbr6bkp4ilsn6.cloudfront.net/assets/videos/wl-taiwantrade/0224_Loading.mp4',
  headQuarterTitle: 'ttmegaexpo'
}

// Support parsing below urls
// https://www.youtube.com/watch?v=072tU1tamd0
// https://youtu.be/072tU1tamd0
// https://www.youtube.com/embed/072tU1tamd0
// https://www.youtube.com/v/072tU1tamd0
// https://www.youtube-nocookie.com/embed/072tU1tamd0
export const YOUTUBE_URL_PATTERN = /(?:youtube(?:-nocookie)?\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i

// Support parsing below urls
// https://www.twitch.tv/RSLeauge
// https://www.twitch.tv/RSLeauge/videos
export const TWITCH_PATTERN = /twitch.tv\/(\w+)/i

// hard code for TVA
export const TVA_PARENT_ACCOUNTS = {
  JP: {
    id: 'JP',
    username: 'tva_admin_001'
  },
  KR: {
    id: 'KR',
    username: 'tva_admin_002'
  },
  HK: {
    id: 'HK',
    username: 'tva_admin_003'
  },
  SG: {
    id: 'SG',
    username: 'tva_admin_004'
  },
  MY: {
    id: 'MY',
    username: 'tva_admin_005'
  },
  TH: {
    id: 'TH',
    username: 'tva_admin_006'
  },
  VN: {
    id: 'VN',
    username: 'tva_admin_007'
  },
  ID: {
    id: 'ID',
    username: 'tva_admin_008'
  },
  PH: {
    id: 'PH',
    username: 'tva_admin_009'
  },
  EU: {
    id: 'EU',
    username: 'tva_admin_010'
  },
  NA: {
    id: 'NA',
    username: 'tva_admin_011'
  },
  NZ: {
    id: 'NZ',
    username: 'tva_admin_012'
  },
  TW: {
    id: 'TW',
    username: 'TVA_HQ_000'
  }
}

export const silentAudio = 'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
